export const downloadFileV2 = (filename: string, signedUrl: string) => {
  const link = document.createElement("a");
  link.href = signedUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};
